import React from 'react';
// import styled from 'styled-components';

// const TruckNumber = styled.div`
//     color:var(--gray);
//     font-weight:800;
//     span{
//         text-decoration: underline;
//         cursor:pointer;
//     }
// `   

export const MB_FUEL_LEVEL = ({currentFuelLevel}) => {
    const hasLevel = currentFuelLevel !== null && currentFuelLevel !== undefined && currentFuelLevel !== '';
    const display = hasLevel ? Math.round(Number(currentFuelLevel)) : '-';
    return <div className="standard_text">
       {`${display}%`}
    </div>
}